import React from 'react';

// Components
import { FormattedMessage } from 'react-intl';
import { PrimaryButton, CancelButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';
import { Stack } from '@capintel/component-lib/stack';
import { Typography } from '@capintel/component-lib/typography';

// Assets
import connectLogo from '../../../images/connect-graphic-gray.svg';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  showModal: boolean;
};

const InviteConfirmationModal = (props: Props) => {
  const { onCancel, onConfirm, showModal } = props;

  return (
    <Modal show={showModal} className="invite-modal" onHide={onCancel} dialogClassName="modal-dialog-centered">
      <Modal.Header className="d-flex flex-column align-items-center">
        <img alt="" src={connectLogo} />
        <Stack gap="075">
          <Typography variant="headerMd" as="h1">
            <FormattedMessage id="InviteConfirmationModal.Title" />
          </Typography>
        </Stack>
      </Modal.Header>

      {
        // TODO - Add back with CON-815
        /* <Modal.Body>
        <div className="invite-modal-text">
          <FormattedMessage id="InviteConfirmationModal.Text" />
        </div>
      </Modal.Body> */
      }

      <Modal.Footer className="d-flex flex-column align-items-center">
        <PrimaryButton className="submit-button" onClick={onConfirm}>
          <FormattedMessage id="InviteConfirmationModal.SendMore" />
        </PrimaryButton>
        <CancelButton onClick={onCancel} />
      </Modal.Footer>
    </Modal>
  );
};

export default InviteConfirmationModal;
